import React, { useMemo, useState } from "react";
import InvoiceForm from "./InvoiceForm";
import InvoicePreview from "./InvoicePreview";
import ArticleIcon from "@mui/icons-material/Article";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import useBillInvoice from "./hooks/useBillInvoice";

const InvoiceGenerate = () => {
  const [activeTab, setActiveTab] = useState("form");
  const { data, method } = useBillInvoice();
  const navigate = useNavigate();

  const invoiceMeta = useMemo(() => {
    const pad = (n) => String(n).padStart(2, "0");
    const d = new Date();
    const invoiceNumber = `INV-${Math.floor(100000 + Math.random() * 900000)}`;
    const invoiceDate = `${d.toLocaleString("en-US", { month: "short" })} ${pad(d.getDate())}, ${d.getFullYear()}`;
    return { invoiceNumber, invoiceDate };
  }, []);

  const handlePreview = () => {
    setActiveTab("preview");
  };

  const topTabsStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    background: "#fcf6f3",
    borderRadius: 999,
    padding: 6,
  };

  const tabBtn = (active) => ({
    borderRadius: 999,
    padding: "10px 14px",
    border: "none",
    background: active ? "#ffffff" : "transparent",
    cursor: "pointer",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    boxShadow: active ? "0 2px 10px rgba(0,0,0,0.08)" : "none",
  });

  return (
    <section>
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <h2 className="page-tittle">
            <i className="fa-solid fa-angle-left cusgap cursor" onClick={() => navigate(-1)}></i>
            Generate Bill
          </h2>
          <hr />
        </header>

        <div>
          <div style={topTabsStyle} className="mb-3">
            <button type="button" style={tabBtn(activeTab === "form")} onClick={() => setActiveTab("form")}>
              <span style={{ fontSize: 16 }}>
                <ArticleIcon />
              </span>
              Invoice Form
            </button>

            <button type="button" style={tabBtn(activeTab === "preview")} onClick={() => setActiveTab("preview")}>
              <span style={{ fontSize: 16 }}>
                <VisibilityIcon />
              </span>
              Preview
            </button>
          </div>

          {activeTab === "form" ? (
            <InvoiceForm
             data={data} method={method}
            //  onGenerate={handlePreview}
             onGenerate={method.generateBillInvoice}
              />
          ) : (
            <InvoicePreview formData={data?.formData} invoiceMeta={invoiceMeta} data={data} method={method} />
          )}
        </div>
      </div>
    </section>
  );
};

export default InvoiceGenerate;
